<script setup lang="ts">
/***
 * template to show array of areas
 */
import type { AreaToContractV1Dto } from '@/openapi';
import { navigationItems } from '@/router/navigation';

import type { PaginatedDataTableCellProps } from './templateTypes';

const area = `${navigationItems?.find((a) => a.name === 'areas')?.icon} sey-icon mr-1`;
const props = defineProps<PaginatedDataTableCellProps<AreaToContractV1Dto[]>>();
</script>

<template>
  <div class="flex flex-col gap-2">
    <div v-for="arrayValue in props.cell" :key="arrayValue.id">
      <div>
        <span :class="area"> </span>
        <RouterLink class="a-inline" :to="`/areas/${arrayValue.area.id}`">{{
          arrayValue.area.name
        }}</RouterLink>
      </div>
    </div>
  </div>
</template>
